// extracted by mini-css-extract-plugin
export default {"buttonsHolder":"gVct6QbDTL5iKpxTcRjk"};